import * as React from "react";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import VideoVisitToolTip from "./VideoVisitToolTip";

class AmbulatoryCareRoomStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = { onTryAgainClick : false}
    }

    componentDidMount() {
        logUI("UI.AmbulatoryCareRoomStatus.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    onTryAgainButtonClick = () => {
        const { onTryAgain, resetJoinVisit } = this.props;
        if (onTryAgain) {
            const { pathName, history, showSharedLinkTryAgain, onTryAgainClick, showTwilioRoomTryAgain } = onTryAgain;
            const activityCode = showSharedLinkTryAgain ? "MBHWeb.UI.VideoVisit.ShareLink.TryAgain.Click" : showTwilioRoomTryAgain ? "MBHWeb.UI.VideoVisit.Timeout.TryAgain.Click" : null;
            if (activityCode)
                logUI(activityCode, new Date(), Tools.getURLPath());
            if (showSharedLinkTryAgain)
                resetJoinVisit();
            if (showTwilioRoomTryAgain && onTryAgainClick)
                onTryAgainClick();
            this.setState({ onTryAgainClick: true });
            history.push({ pathname: pathName.pathname, search: pathName.search });
        }
    }    

    render() {
        const { videoErrorMsg, isFromNonLogin, roomError, onTryAgain  } = this.props;
        const { onTryAgainClick} = this.state;

        return (
             !onTryAgainClick && 
                (<div className={isFromNonLogin ? "" : " container-fluid body-content"}>
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="video-frame video-error">
                            <div className="video-frame__status">
                                <div className="video-status">
                                    <div className="video-status__icon"><span className="icon-error" /></div>
                                        <div className="video-status__msg">{roomError || videoErrorMsg}                                        
                                    </div>
                                    {onTryAgain && (onTryAgain.showSharedLinkTryAgain || onTryAgain.showTwilioRoomTryAgain) && <div className="video-status__try-again"><span>Please <button className="btn text-btn" onClick={this.onTryAgainButtonClick}>try again.</button></span></div>}                                            
                                </div>
                            </div>                           
                        </div>                   
                        <VideoVisitToolTip />
                    </div>
                </div>
                </div>)             
        );
    }

}

export default AmbulatoryCareRoomStatus;